import api from './data.services'
import { authService } from './'

const contactsSrv = 'contacts/pages'
const reasonsContactSrv = 'reasons/contacts'
const contactSrv = 'contacts'
const patientSrv = 'patients'

const getContacts = async (filter: string = '', status: number = 0, page: number = 1, limit: number = 5) => {
  try {
    const resp: any = await api.post(
      contactsSrv,
      {
        filter,
        status,
        page,
        limit
      },
      authService.getToken()
    )

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : [])
    }
  } catch(error) {
    return {
      status: 'Error',
      data: {},
      message: 'Error server al obtener contactos!'
    }
  }
}

const getReasonsContact = async () => {
  try {
    const resp: any = await api.get(reasonsContactSrv, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data && resp.data.reasonsContacts ? resp.data.reasonsContacts : [])
    }
  } catch(error) {
    return {
      status: 'Error',
      data: {},
      message: 'Error server al obtener motivo del contacto!'
    }
  }
}

const getPatientById = async (patientId: number) => {
  try {
    const resp: any = await api.get(`${patientSrv}/${patientId}`, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data && resp.data.patient ? resp.data.patient : {})
    }
  } catch(error) {
    return {
      status: 'Error',
      data: {},
      message: 'Error server al obtener motivo del contacto!'
    }
  }
}

const postContact = async (data: any) => {
  try {
    const resp: any = await api.post(contactSrv, data, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : {})
    }
  } catch(error) {
    return {
      status: 'Error',
      data: {},
      message: 'Error server al guardar contacto!'
    }
  }
}

export const contactService = {
  getContacts,
  getReasonsContact,
  getPatientById,
  postContact
}